import type { AxiosError } from 'axios';
import { Platform } from 'react-native';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';

export type ReportAttachment = {
  uri: string;
  name: string;
  type: string;
  file?: File;
};

type Variables = {
  file?: ReportAttachment;
  description: string;
};
export type CreateReportResponse = {
  data: {
    id: number;
  };
};

const getReportFileFormValue = (file: NonNullable<Variables['file']>) => {
  if (Platform.OS === 'web') {
    if (!file.file) {
      throw new Error('Web report upload requires a File object.');
    }

    return file.file;
  }

  return {
    uri: file.uri,
    name: file.name,
    type: file.type,
  };
};

export const useCreateReport = createMutation<
  CreateReportResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) => {
    const formData = new FormData();

    if (variables.file) {
      formData.append('file', getReportFileFormValue(variables.file) as any);
    }
    formData.append('description', variables.description);

    return client({
      url: `v2/reports`,
      method: 'POST',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      });
  },
});
